import apiBase from './api-base';

export const contentApi = {
  getPage: async (page: string): Promise<Record<string, string>> => {
    const response = await apiBase.get<Record<string, string>>(`/content/?page=${page}`);
    return response.data;
  },

  bulkUpdate: async (data: Record<string, string>): Promise<{ updated: string[] }> => {
    const response = await apiBase.patch<{ updated: string[] }>('/content/update/', data);
    return response.data;
  },
};

export default contentApi;
